"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CodeIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M11.9806 19.1961C11.8723 19.7377 11.3454 20.0889 10.8039 19.9806C10.2623 19.8723 9.91111 19.3455 10.0194 18.8039L12.0194 4.80389C12.1277 4.26233 12.6546 3.91112 13.1961 4.01943C13.7377 4.12774 14.0889 4.65457 13.9806 5.19613L11.9806 19.1961ZM5.41421 12L8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071C8.31658 17.0976 7.68342 17.0976 7.29289 16.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L7.29289 7.2929C7.68342 6.90238 8.31658 6.90238 8.70711 7.2929C9.09763 7.68343 9.09763 8.31659 8.70711 8.70712L5.41421 12ZM15.2929 15.2929L18.5858 12L15.2929 8.70712C14.9024 8.31659 14.9024 7.68343 15.2929 7.2929C15.6834 6.90238 16.3166 6.90238 16.7071 7.2929L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071C14.9024 16.3166 14.9024 15.6834 15.2929 15.2929Z" })
  );
}